import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only show spinner for authentication/login related requests
    const isAuthRequest = request.url.includes('auth') ||
                          request.url.includes('auth/user') || 
                          request.url.includes('userinfo.openid') ||
                          request.url.includes('login') || 
                          request.url.includes('token') ||
                          request.url.includes('oauth') ||
                          request.url.includes('oken.oauth2');

    if (isAuthRequest) {
      if (this.activeRequests === 0) {
        this.loadingService.show();
      }
      this.activeRequests++;

      return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingService.hide();
          }
        })
      );
    }

    return next.handle(request);
  }
}
